import {
    ONLINE_CATALOG_SET_PAGES, ONLINE_CATALOG_TOGGLE_MODAL_MESSAGE, ONLINE_CATALOG_ERROR,
    ONLINE_CATALOG_SET_RIGHT_PAGE, ONLINE_CATALOG_SET_LEFT_PAGE, ONLINE_CATALOG_SET_BROWSE_STATUS, ONLINE_CATALOG_SET_PAGES_LOADED
} from '../Actions/OnlineCatalog.action';

const DEFAULT_STATE = {
    showModal: false,
    modalMessage: '',
    pages: [],
    error: '',
    currentPage: 1,
    leftPage: '',
    rightPage: '',
    spreadWidthLimit: 1000,
    isRightBrowse: true,
    pageFlipClass: '',
    tableOfContents: [],
    leftPageSet: false,
    rightPageSet: false
};

export const onlineCatalog = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case ONLINE_CATALOG_SET_RIGHT_PAGE:
    case ONLINE_CATALOG_SET_LEFT_PAGE:
    case ONLINE_CATALOG_SET_PAGES:
    case ONLINE_CATALOG_TOGGLE_MODAL_MESSAGE:
    case ONLINE_CATALOG_SET_BROWSE_STATUS:
    case ONLINE_CATALOG_SET_PAGES_LOADED:
    case ONLINE_CATALOG_ERROR:
        return {
            ...state,
            ...action.payload,
        }
    default:
        return state;
    }
}